<template>
  <div class="pi-check" :class="{ 'is-compact': compact }">
    <div v-for="group in groups" :key="group.key" class="pi-check__group">
      <p class="pi-check__title">{{ group.label }}</p>
      <ul class="pi-check__list">
        <li v-for="item in group.items" :key="item.key" class="pi-check__item" :class="'is-' + item.state">
          <span class="pi-check__mark" aria-hidden="true">{{ markOf(item) }}</span>
          <span class="pi-check__label">{{ item.label }}</span>
          <span v-if="item.reached" class="pi-check__when">{{ item.dateText }}<template v-if="item.dayText"> · {{ item.dayText }}</template></span>
          <span v-else-if="item.measured" class="pi-check__when">ainda não</span>
          <span v-for="note in item.notes" :key="note" class="pi-badge" :class="note === 'não medido' ? 'pi-badge--muted' : 'pi-badge--info'">{{ note }}</span>
          <span class="pi-sr">{{ stateText(item) }}</span>
        </li>
      </ul>
    </div>
    <p v-if="!groups.length" class="pi-muted">Sem marcos medidos para esta empresa.</p>
  </div>
</template>

<script>
import { milestoneGroups } from "./piOnboardingModel.js";

const MARKS = { done: "✓", pending: "○", unmeasured: "?" };
const STATES = { done: "Atingido", pending: "Não atingido", unmeasured: "Não medido" };

export default {
  name: "pi-onboarding-checklist",
  props: {
    milestones: { type: [Object, Array], default: null },
    skippedSetup: { type: Boolean, default: false },
    compact: { type: Boolean, default: false },
  },
  computed: {
    groups() {
      return this.milestones ? milestoneGroups(this.milestones, this.skippedSetup) : [];
    },
  },
  methods: {
    markOf(item) {
      return MARKS[item.state] || "";
    },
    stateText(item) {
      return STATES[item.state] || "";
    },
  },
};
</script>

<style src="./pi.css"></style>

<style scoped>
.pi-check {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(260px, 1fr));
  gap: 8px 20px;
}

.pi-check.is-compact {
  grid-template-columns: repeat(auto-fill, minmax(230px, 1fr));
  gap: 4px 16px;
}

.pi-check__title {
  margin: 0 0 4px;
  font-size: 11px;
  font-weight: 700;
  color: #4e5560;
  text-transform: uppercase;
}

.pi-check__list {
  margin: 0;
  padding: 0;
  list-style: none;
}

.pi-check__item {
  display: flex;
  flex-wrap: wrap;
  align-items: baseline;
  gap: 2px 6px;
  padding: 2px 0;
  font-size: 12px;
  color: #1f2933;
}

.pi-check__mark {
  flex: 0 0 14px;
  font-weight: 700;
  text-align: center;
}

.pi-check__item.is-done .pi-check__mark {
  color: #12a150;
}

.pi-check__item.is-pending .pi-check__mark,
.pi-check__item.is-pending .pi-check__label {
  color: #6b7280;
}

.pi-check__item.is-unmeasured .pi-check__mark {
  color: #b35c00;
}

.pi-check__when {
  font-size: 11px;
  color: #4e5560;
}
</style>



// WEBPACK FOOTER //
// src/vue/pages/components/pi/piOnboardingChecklist.vue